import apiFetch from '../apiFetch'

export default function (fechaReferencia, token) {
  return apiFetch({endPoint: `Planning/getPrevisionVerracos`, method: 'POST', body: {fechaReferencia}, token: token})
}